import fetch from 'isomorphic-fetch';
import { url } from '@ts/utils/url';

export type FooterLinks = {
  icon: string;
  id: string;
  title: string;
  url: string;
};

export type FooterResDto = {
  company: FooterLinks[];
  legal: FooterLinks[];
  services: FooterLinks[];
};

export class FooterService {
  constructor(private readonly portalUrl: string = url.getPortalUrl()) {}

  getFooterLinks = async () => {
    const url = `${this.portalUrl}/@actions`;

    const settings: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    const response = await fetch(url, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const res = await response.json();

    const footerRes: FooterResDto = {
      legal: res.legal_actions,
      company: res.company_actions,
      services: res.services_actions,
    };

    return footerRes;
  };
}
